export const walkingCircleSelector = ({walkingCircle}) => walkingCircle